import { render, staticRenderFns } from "./listDataField.vue?vue&type=template&id=3031ffa0"
import script from "./listDataField.vue?vue&type=script&lang=js"
export * from "./listDataField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports